import type { ParserParams } from "../interface";

const paramsParser: ParserParams = {
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 0,
  x: 0,
  y: 0,
  qx: null,
  qy: null,
};

export default paramsParser;
